<div id="post-div">
  <mat-card appearance="outlined" class="mat-elevation-z1">
    <mat-card-header>
      <!-- <mat-card-title> {{ title }} </mat-card-title> -->
      <mat-card-title-group>
        <mat-card-title>
          {{ title }}
        </mat-card-title>
        @if (subTitle) {
          <mat-card-subtitle>
            {{ subTitle }}
          </mat-card-subtitle>
        }
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      <div id="post-content" [innerHTML]="content"></div>
    </mat-card-content>
  </mat-card>
</div>
